import { DataLayer } from "@grandvisionhq/analytics";
import { mapProductListingToDataLayerProductObject } from "../../../Mappers/DataLayer/Mappers/ProductListingMapper.js";
const createImpressionEvent = (product, position, location, currency) => {
  return {
    event: "gvProductImpressions",
    atfEcommerce: {
      ecommerce: {
        currencyCode: currency,
        // ISO4217
        impressions: [
          {
            ...mapProductListingToDataLayerProductObject(
              DataLayer.DataLayerTypes.PurchaseType.OneTime,
              product,
              product.masterVariant.sku || "undefined"
            ),
            list: location,
            position
          }
        ]
      }
    }
  };
};
const createInteractionEvent = (product, position, location, currency) => {
  return {
    event: "gvProductClick",
    atfEcommerce: {
      ecommerce: {
        currencyCode: currency,
        // ISO4217
        click: {
          actionField: { list: location },
          products: [
            {
              ...mapProductListingToDataLayerProductObject(
                DataLayer.DataLayerTypes.PurchaseType.OneTime,
                product,
                product.masterVariant.sku || "undefined"
              ),
              position
            }
          ]
        }
      }
    }
  };
};
export {
  createImpressionEvent,
  createInteractionEvent
};
//# sourceMappingURL=ProductPromotionEvents.js.map
